import useModelStoreModule from '@/views/models/common/useModelStoreModule'
import activityLogModel from '@/views/models/activity_logs/activityLogModel'
import axios from '@/libs/axios'

const {
  RESOURCE_ENDPOINT,
  deleteOne,
} = useModelStoreModule(activityLogModel)

const fetchAll = (ctx, queryParams) => new Promise((resolve, reject) => {
  axios
    .get(`${RESOURCE_ENDPOINT}/${queryParams.subject_type}/${queryParams.subject_id}`, { params: { page: queryParams.page } })
    .then(response => resolve(response))
    .catch(error => reject(error))
})

const create = (ctx, itemData) => new Promise((resolve, reject) => {
  axios
    .post(`${RESOURCE_ENDPOINT}/${itemData.subject_type}/${itemData.subject_id}`, activityLogModel.toArray(itemData))
    .then(response => {
      if (response && ((response.status === 201))) {
        return resolve(activityLogModel.fromArray(response.data.data))
      }
      return reject(new Error('Operation Failed!'))
    })
    .catch(error => {
      if (error?.response?.status === 422) {
        error.response.data.errors = activityLogModel.resolveValidationErrors(error.response.data.errors)
      }
      return reject(error)
    })
})

export default {
  name: 'activity_logs',
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAll,
    create,
    deleteOne,
  },
}
